import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-14 «Співробітники і ФОП» (F-021). Тека с этим файлом — и есть
// регистрация (`../registry.ts`): пункт «Співробітники і ФОП» раздела «ГРОШІ» оживает вместе
// с ней (решение 028). Вход — пункт меню, часть «Зарплата (ФОП)» на `S-01`, дело «ставки не
// внесені» и прямой адрес.
export const meta: SurfaceMeta = {
  code: "S-14",
  // Название — слово словаря по коду (`G117`), читается при показе.
  get title_uk() {
    return w("s14_title");
  },
  path: "/s-14",
};
